import { render } from "./EditImprestModal.vue?vue&type=template&id=31235e96&scoped=true"
import script from "./EditImprestModal.vue?vue&type=script&lang=js"
export * from "./EditImprestModal.vue?vue&type=script&lang=js"

import "./EditImprestModal.vue?vue&type=style&index=0&id=31235e96&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31235e96"]])

export default __exports__